'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_AGENT_TYPING_TIMEOUT_ID = exports.ADD_AGENT_TYPING_TIMEOUT_ID = 'ADD_AGENT_TYPING_TIMEOUT_ID';
var REMOVE_AGENT_TYPING_TIMEOUT_ID = exports.REMOVE_AGENT_TYPING_TIMEOUT_ID = 'REMOVE_AGENT_TYPING_TIMEOUT_ID';

var START_BOT_TYPING = exports.START_BOT_TYPING = 'START_BOT_TYPING';
var STOP_BOT_TYPING = exports.STOP_BOT_TYPING = 'STOP_BOT_TYPING';